module.exports = __webpack_public_path__ + "img/icon_fly_wghn.460653a7.svg";